import { makeStyles } from 'tss-react/mui';

const useStylesFieldDate: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  fieldDate: {
    width: '100%',
    minWidth: 100,
    '& input': {
      fontSize: 14,
      paddingLeft: 10,
      minWidth: 90,
    },
    '& button': {
      padding: 0,
      marginLeft: -25,
      marginTop: 3,
      width: 24,
    },
    '& > div > div': {
      width: '100%',
      '& > div': {
        height: 40,
        '& > div > button, & > svg': {
          marginRight: 5,
        },
        '&::before': {
          display: 'none',
        },
      },
    },
  },
  fieldDateBordered: {
    '& > div > div > div': {
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.palette.info.main}`,
    },
  },
}));

export default useStylesFieldDate;
